// extracted by mini-css-extract-plugin
export default {"editIcon":"OnDemand_editIcon__Pyepz","buttonRates":"OnDemand_buttonRates__rVy7l"};